export default __webpack_public_path__ + "static/media/credit-machine.dfa233ad.svg";